import { Controller } from "@hotwired/stimulus";
import { MOBILE_QUERY } from "../helpers/breakpoints";

// Marks a row's link so the server answers with a Turbo Stream instead of the
// full page below the mobile breakpoint — e.g. a detail that then arrives as a
// bottom sheet over the list rather than replacing the page.
//
// The server cannot tell the viewport apart, so the row states which of the two
// representations it wants: with data-turbo-stream Turbo asks for a stream,
// without it the response is the page.
//
// Kept in sync on resize because a rotated phone or a resized window must not be
// left with the request kind of the previous width.
export default class extends Controller {
  static targets = ["link"];

  connect() {
    this.query = window.matchMedia(MOBILE_QUERY);
    this.update = () => this.applyRequestKind();
    this.query.addEventListener("change", this.update);
    this.applyRequestKind();
  }

  disconnect() {
    this.query?.removeEventListener("change", this.update);
  }

  applyRequestKind() {
    const link = this.hasLinkTarget ? this.linkTarget : null;
    if (!link) return;

    if (this.query.matches) {
      link.setAttribute("data-turbo-stream", "true");
    } else {
      link.removeAttribute("data-turbo-stream");
    }
  }
}
